.k6{right:0.25rem;}